var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('plan-fields',{attrs:{"plan":_vm.plan,"editMode":false}}),_c('service-plans-table',{attrs:{"servicePlans":_vm.servicePlans,"editMode":false,"canEditAssignments":_vm.canEditAssignments}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }